import FournisseurView from "@features/achats/components/fournisseurs/FournisseurView";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Truck } from "lucide-react";

export const Route = createFileRoute("/_app/achats/fournisseurs/$id/view")({
  staticData: {
    title: "Détails Fournisseur",
    icon: Truck,
    permission: PERMISSIONS.ACHATS.FOURNISSEURS.VIEW,
    module: "achats",
    showInTab: false,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: FournisseurView,
});
